import { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";
import { Menu, X } from "lucide-react";
import Logo from "./Logo";

const links = [
  { to: "/autot", label: "Autot" },
  { to: "/rahoituslaskuri", label: "Rahoituslaskuri" },
  { to: "/tiedotteet", label: "Tiedotteet" },
  { to: "/vaihtoauto", label: "Myy meille" },
  { to: "/meista", label: "Meistä" },
  { to: "/yhteystiedot", label: "Yhteystiedot" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => setOpen(false), [pathname]);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      className={`fixed top-0 inset-x-0 z-50 border-b transition-colors duration-300 ${
        scrolled ? "bg-[#050505] lg:bg-[#050505]/85 lg:backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
      data-testid="navbar"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 h-20 flex items-center justify-between">
        <Logo compact />
        <nav className="hidden lg:flex items-center gap-8">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`nav-${l.to.replace("/", "")}`}
              className={`text-[13px] font-medium uppercase tracking-[0.14em] transition-colors duration-200 hover:text-[#ff5a00] ${
                pathname === l.to ? "text-[#ff5a00]" : "text-white/70"
              }`}
            >
              {l.label}
            </Link>
          ))}
          <Link
            to="/autot"
            className="bg-[#ff5a00] text-white text-[13px] font-semibold uppercase tracking-[0.12em] px-6 py-3 hover:bg-white hover:text-black transition-colors duration-300"
            data-testid="nav-cta"
          >
            Selaa autoja
          </Link>
        </nav>
        <button
          className="lg:hidden text-white p-2"
          onClick={() => setOpen((v) => !v)}
          data-testid="mobile-menu-toggle"
          aria-label="Valikko"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>
      {open && (
        <div className="lg:hidden bg-[#050505] border-t border-white/10 px-6 py-6 flex flex-col gap-5">
          {links.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              data-testid={`mobile-nav-${l.to.replace("/", "")}`}
              className="text-sm font-medium uppercase tracking-[0.14em] text-white/80"
            >
              {l.label}
            </Link>
          ))}
        </div>
      )}
    </header>
  );
}
